import type { ReactElement } from 'react';
import { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { Security } from '@okta/okta-react';

import { LoginComponent } from '../../components';
import type { OktaWidgetConfig } from '../../components/LoginComponent';
import { environment } from '../../environment';
import { APIProvider } from '../../networking';
import RootRoutes from '../../shared/RootRoutes';
import constants from '../../templates/common/constants.json';
import { oktaAuth } from '../../utils/auth';
import { oktaConfig, oktaOnAuthRequired } from '../../utils/config';
import { restoreOriginalUri } from '../../utils/config/restore-original-uri';
import { updateLocalStorage } from '../../utils/storage';
import Logout from '../Logout';

import '../../../node_modules/@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';

interface AppState {
  isSessionTimeout: boolean;
}

class App extends Component<Record<string, never>, AppState> {
  constructor(props: Record<string, never>) {
    super(props);
    this.state = {
      isSessionTimeout: false
    };
  }

  componentDidMount(): void {
    this.checkTimeout();
  }

  checkTimeout(): void {
    const isSessionTimeout = !!(updateLocalStorage && updateLocalStorage.getItem('sessionTimeout'));
    if (isSessionTimeout) {
      updateLocalStorage.removeItem('sessionTimeout');
      this.setState({ isSessionTimeout });
    }
  }

  render(): ReactElement {
    const {
      server: { path }
    } = environment();
    const { isSessionTimeout } = this.state;
    const language = 'en';
    const i18n = constants as Record<string, Record<string, string>>;
    const { sessionExpired = 'Session Expired' } = i18n[language];
    return (
      <Fragment>
        <Router basename={path}>
          <Security oktaAuth={oktaAuth} onAuthRequired={oktaOnAuthRequired} restoreOriginalUri={restoreOriginalUri}>
            <APIProvider>
              <Switch>
                <Route
                  exact
                  path={[oktaConfig.loginPath as string, '/']}
                  component={() => (
                    <div>
                      {isSessionTimeout && (
                        <div className="okta-session-timeout" role="alert">
                          <span>{sessionExpired}</span>
                        </div>
                      )}
                      <LoginComponent
                        i18n={i18n}
                        language={language}
                        oktaConfig={oktaConfig as unknown as OktaWidgetConfig}
                      />
                    </div>
                  )}
                />
                <Route exact path={oktaConfig.logoutPath as string} component={Logout} />
                <Route component={RootRoutes} />
              </Switch>
            </APIProvider>
          </Security>
        </Router>
      </Fragment>
    );
  }
}

export default App;
